import { Button } from '@/components';
import { useMe } from '@/features/authentication/_hooks/me';
import { ProjectGroupFormModal } from '@/features/project/groups/_components/ProjectGroupFormModal';
import { useCreateGroup } from '@/features/project/groups/_hooks/group';
import { useRecursiveOrganizationFilteredByKey } from '@/features/tenant-manager/hooks';
import { useMessage } from '@/providers';
import { type ComponentProps, type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  buttonType?: ComponentProps<typeof Button>['type'];
};
export const GroupCreateModalButton: FC<Props> = ({ buttonType }) => {
  const me = useMe();
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const [open, setOpen] = useState(false);

  const organizationIds = useRecursiveOrganizationFilteredByKey({
    params: { ids: me.data?.organizationIds ?? [] },
    enabled: !!me.data,
    options: { separator: undefined, filterBy: 'id', reverse: true },
  });

  const { mutateAsync } = useCreateGroup();

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
        }}
        type={buttonType}
      >
        {t('create-project-group')}
      </Button>
      <ProjectGroupFormModal
        type="new"
        open={open}
        onClose={() => setOpen(false)}
        initialValues={{
          organizationIds:
            organizationIds.data?.length === 1
              ? organizationIds.data[0]
              : undefined,
        }}
        isLoading={organizationIds.isLoading}
        onSubmit={async ({ ...values }) => {
          await mutateAsync({
            ...values,
            targetType: 'project',
            sharedOrganizationIds: [],
          });
          openMessage('success', t('message-create-completed'));
          setOpen(false);
        }}
      />
    </>
  );
};
